var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaBrandLogoOriginal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 244,
    height: 48,
    viewBox: "0 0 244 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#BB4660"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B860B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "205.704%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CE6CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E66783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: "50%",
    x2: "50%",
    y1: "205.704%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CE6CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E66783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: "50%",
    x2: "50%",
    y1: "205.704%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CE6CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E66783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: "50%",
    x2: "50%",
    y1: "205.704%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CE6CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E66783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: "50%",
    x2: "50%",
    y1: "205.704%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CE6CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E66783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: "50%",
    x2: "50%",
    y1: "205.704%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CE6CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E66783"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: "50%",
    x2: "50%",
    y1: "205.704%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#CE6CC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#E66783"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    width: "110.7%",
    height: "167%",
    x: "-5.4%",
    y: "-33.5%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(8.697 7.48)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(203.326)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.25708089,33 C2.58680504,33 1.94761445,32.8270883 1.40815572,32.4799696 C0.329238267,31.7863798 -0.18431608,30.5054081 0.0598327076,29.1182286 L3.49410598,9.64072472 C3.73825476,8.25419274 4.70513577,6.97257351 6.02820202,6.27898372 C7.35062065,5.58604153 8.83105601,5.58604153 9.91062107,6.27898372 L25.0601505,16.0177356 C26.139068,16.7106778 26.6532699,17.9922971 26.4084735,19.3794766 C26.1636771,20.7660086 25.1980913,22.0482755 23.8750251,22.7418652 L5.29057478,32.4799696 C4.62871785,32.8270883 3.92735674,33 3.25708089,33"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "url(#a)",
    strokeWidth: 2,
    d: "M8.27760617,26.577247 C7.62287295,26.577247 6.99857738,26.4082209 6.47336606,26.0701687 C5.42035298,25.3934168 4.91910322,24.1428828 5.15742352,22.7893789 L8.50815516,3.78722046 C8.74647546,2.43436417 9.68874731,1.1838302 10.9800807,0.507078252 C12.2707665,-0.169026084 13.7142881,-0.169026084 14.7679488,0.507078252 L29.5483408,10.0081575 C30.6007062,10.6849094 31.1026036,11.9354434 30.8642833,13.2889473 C30.6253154,14.6418036 29.6830435,15.8923375 28.3917102,16.5690895 L10.2599389,26.0701687 C9.61491982,26.4082209 8.93104417,26.577247 8.27760617,26.577247"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)",
    transform: "translate(0 .825)"
  }, /*#__PURE__*/React.createElement("polyline", {
    fill: "#FFF",
    points: "4.353 .033 9.621 .033 5.267 23.513 0 23.513 4.353 .033"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M16.6844678 4.0311639 11.4175894 4.0311639 12.1585022.0330211813 17.4258965.0330211813 16.6844678 4.0311639ZM13.0727761 23.5131449 7.80538174 23.5131449 11.070867 5.90305212 16.3372295 5.90305212 13.0727761 23.5131449 13.0727761 23.5131449ZM18.8762487 5.90305212 23.7943409 5.90305212 23.4471026 7.7754563 23.5105652 7.7754563C24.2086536 6.91845345 25.6197931 5.30041556 28.760933 5.30041556 30.4419175 5.30041556 32.1848167 5.99798802 32.9835166 6.82351755 33.7827323 7.64801517 34.6025864 9.044192 33.9612531 12.5026448L31.9201313 23.5131449 26.6532529 23.5131449 28.4358807 13.8988216C28.6649652 12.6615592 29.112299 10.2499811 26.3514187 10.2499811 23.3377199 10.2499811 22.8547851 12.851947 22.6551102 13.9308109L20.8786738 23.5131449 15.6112794 23.5131449 18.8762487 5.90305212M43.8634799 19.166216C46.4019832 19.166216 48.5204983 17.3252851 48.9905342 14.7867818 49.5142295 11.9629549 47.8961916 10.2499811 45.548592 10.2499811 43.2959283 10.2499811 40.9612276 12.0584067 40.4844843 14.6283833 39.960789 17.4522103 41.6737628 19.166216 43.8634799 19.166216ZM53.0340811 21.3863745C52.5459867 24.0208456 52.0434456 25.7023461 50.9104063 27.1929428 49.1344859 29.4146492 45.5707781 31.35 41.2238492 31.35 35.0999679 31.35 33.4659354 27.6691702 33.5815095 25.1626561L39.6739175 25.1626561C40.1119641 26.9086511 42.0787882 26.9086511 42.4280904 26.9086511 43.0941895 26.9086511 46.7234237 26.8446726 47.599517 22.1164522L47.7001284 21.5772782 47.6366658 21.5772782C46.9091679 22.5926795 45.1095135 24.0843082 42.3491491 24.0843082 37.5579821 24.0843082 34.1356462 20.466941 35.1825209 14.8187711 36.2995655 8.79034167 41.2563544 5.33188888 45.8251444 5.33188888 47.7930004 5.33188888 49.5988463 6.02997729 50.2685571 7.55307928L50.3320197 7.55307928 50.6374656 5.90305212 55.90486 5.90305212 53.0340811 21.3863745 53.0340811 21.3863745ZM71.4242993 23.5131449 66.4432605 23.5131449 66.7899829 21.6412567 66.7265203 21.6412567C65.2297321 23.8939204 63.0369192 24.0843082 61.704721 24.0843082 60.625857 24.0843082 58.1343057 23.8304579 56.9445113 21.8626018 55.8718388 20.1176388 55.916727 18.8483871 56.3640608 16.4373249L58.3164382 5.90305212 63.5838326 5.90305212 61.7779867 15.6437847C61.5545778 16.8495737 61.1253024 19.166216 63.9491294 19.166216 65.4722314 19.166216 67.1103915 18.3731917 67.6278954 15.5803221L69.4223902 5.90305212 74.6892686 5.90305212 71.4242993 23.5131449M83.5843493 19.1976893C86.8838877 19.1976893 88.5122447 16.4058516 88.8300736 14.6918459 89.223748 12.5661074 88.1995754 10.2179918 85.2173499 10.2179918 82.2026193 10.2179918 80.3998692 12.7564951 80.0288968 14.7553085 79.7234509 16.4058516 80.4112202 19.1976893 83.5843493 19.1976893ZM92.4613716 23.5131449 87.1944932 23.5131449 87.5474071 21.6087515 87.4839445 21.6087515C86.2781554 23.3222412 83.9413909 24.1152655 81.8785989 24.1152655 76.2944076 24.1152655 73.8379413 19.7373792 74.7733694 14.6918459 75.843978 8.91675088 80.671262 5.30041556 85.3674931 5.30041556 88.2547827 5.30041556 89.6143266 6.69607643 90.0487615 7.7754563L90.1122241 7.7754563 90.4594625 5.90305212 95.7263409 5.90305212 92.4613716 23.5131449 92.4613716 23.5131449Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M104.714294,19.1646681 C108.013832,19.1646681 109.642189,16.3728304 109.960018,14.6588247 C110.354208,12.5330862 109.330036,10.1849706 106.347294,10.1849706 C103.332564,10.1849706 101.529814,12.7234739 101.159357,14.7222873 C100.853395,16.3728304 101.541165,19.1646681 104.714294,19.1646681 Z M113.591316,23.4801238 L108.324438,23.4801238 L108.677351,21.5762463 L108.613889,21.5762463 C107.4081,23.2892201 105.071851,24.0827603 103.009059,24.0827603 C97.4248679,24.0827603 94.9684016,19.7043581 95.9038298,14.6588247 C96.9744384,8.8837297 101.801722,5.26739438 106.497438,5.26739438 C109.385243,5.26739438 110.744271,6.66305525 111.178706,7.74243511 L111.242684,7.74243511 L111.589407,5.87003094 L116.856285,5.87003094 L113.591316,23.4801238 L113.591316,23.4801238 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#d)",
    points: "128.438 5.87 127.697 9.868 125.159 9.868 122.636 23.48 117.368 23.48 119.892 9.868 117.29 9.868 118.031 5.87 120.633 5.87 121.721 0 126.989 0 125.9 5.87"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#e)",
    points: "135.768 5.87 138.307 5.87 137.565 9.868 135.027 9.868 132.504 23.48 127.237 23.48 129.76 9.868 127.158 9.868 127.9 5.87 130.502 5.87 131.589 0 136.857 0 135.768 5.87"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M145.678617,19.1646681 C148.977639,19.1646681 150.605996,16.3728304 150.924341,14.6588247 C151.318016,12.5330862 150.293843,10.1849706 147.311618,10.1849706 C144.296887,10.1849706 142.494137,12.7234739 142.123165,14.7222873 C141.817203,16.3728304 142.504972,19.1646681 145.678617,19.1646681 Z M154.555639,23.4801238 L149.288245,23.4801238 L149.641675,21.5762463 L149.577696,21.5762463 C148.371907,23.2892201 146.035659,24.0827603 143.972867,24.0827603 C138.388675,24.0827603 135.932209,19.7043581 136.868153,14.6588247 C137.938246,8.8837297 142.76553,5.26739438 147.461761,5.26739438 C150.34905,5.26739438 151.708594,6.66305525 152.143029,7.74243511 L152.206492,7.74243511 L152.553214,5.87003094 L157.820609,5.87003094 L154.555639,23.4801238 L154.555639,23.4801238 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M176.168003,16.7845633 C174.475151,20.782706 170.346987,24.0507711 165.58781,24.0507711 C160.257469,24.0507711 156.940904,19.8627565 157.911417,14.6273514 C158.870063,9.45489294 163.676709,5.26739438 168.943587,5.26739438 C173.607829,5.26739438 176.812431,8.34507167 176.90066,12.6605273 L171.570319,12.6605273 C171.223081,11.4542223 170.410966,10.1849706 168.221765,10.1849706 C165.738985,10.0585614 163.674645,12.1203214 163.204093,14.6588247 C162.727866,17.2293173 164.056452,19.1326789 166.562966,19.1326789 C168.752168,19.1326789 170.034834,17.8634272 170.805672,16.7845633 L176.168003,16.7845633"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#h)",
    points: "180.613 0 185.881 0 183.61 12.248 183.673 12.248 189.742 5.87 195.993 5.87 187.926 13.612 192.538 23.48 186.572 23.48 183.161 15.008 183.098 15.008 181.527 23.48 176.26 23.48 180.613 0"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "url(#i)",
    points: "180.085 31.227 174.817 31.222 175.818 25.828 181.085 25.833 180.085 31.227"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaBrandLogoOriginal);
export default __webpack_public_path__ + "static/media/LA-brand-logo-original.667c8a00d38919e69295c3fc06649067.svg";
export { ForwardRef as ReactComponent };